<script lang="ts">
	import ReviewCard from "@components/ReviewCard.svelte";
	import Carousel from "@components/common/Carousel.svelte";
	import type { EmblaCarouselType } from "embla-carousel";
	import autoscroll from "embla-carousel-auto-scroll";
	import type { ClassValue } from "svelte/elements";
	import type { Review } from "@core/schema/Review.js";

	let api = $state<EmblaCarouselType>();

	const { class: customClass, reviews }: { class?: ClassValue; reviews: Review[] } = $props();
</script>

{#if reviews.length > 0}
	<div
		role="presentation"
		onmouseleave={(): void => {
			api?.plugins().autoScroll.play();
		}}
		class={[customClass, "py-8 md:py-16 lg:py-20 full-width"]}
	>
		<Carousel
			bind:api
			items={reviews}
			class="h-full"
			options={{ loop: true }}
			plugins={[autoscroll({ playOnInit: true, stopOnMouseEnter: true, startDelay: 0, direction: "backward" })]}
		>
			{#snippet item(review)}
				<ReviewCard class="mx-1" {review} />
			{/snippet}
		</Carousel>
	</div>
{/if}
